import { render, staticRenderFns } from "./model-manage.vue?vue&type=template&id=005621f4&scoped=true"
import script from "./model-manage.vue?vue&type=script&lang=js"
export * from "./model-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005621f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005621f4')) {
      api.createRecord('005621f4', component.options)
    } else {
      api.reload('005621f4', component.options)
    }
    module.hot.accept("./model-manage.vue?vue&type=template&id=005621f4&scoped=true", function () {
      api.rerender('005621f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flow/model/model-manage.vue"
export default component.exports